import ReactGA from 'react-ga4'
import { API } from '../config/api'
import { History, Location } from 'history'
import { store } from '../store'
export * from 'react-ga4'

export function trackPageView(location: Location) {
  ReactGA.send({ hitType: 'pageview', page: location.pathname })
}
export function init(history: History) {
  ReactGA.initialize(API.GATRACKINGID)
  store.subscribe(() => {
    const authState = store.getState().auth
    if (authState && authState.given_name) {
      const newUserId = authState.given_name
      ReactGA.set({ userId: newUserId })
    }
  })
  trackPageView(history.location)
  history.listen(trackPageView)
}
export function trackEvent(category: string, action: string) {
  ReactGA.event({ category, action })
}

export function trackException(description: string, isFatal: boolean) {
  ReactGA.event({
    category: 'Exception',
    action: 'Exception',
    label: description,
    value: isFatal ? 1 : 0,
  })
}
